import { CreateListingSummary } from './CreateListingSummary';

export const CreateListingSummaryStatusGuard = () => <CreateListingSummary />;
